import { useQuery } from '@tanstack/react-query';
import {
  fundingCalcPromptApi,
  fundingCalcPromptKeys,
  fundingSourcesKeys,
} from './fundingCalcPromptApi';

export function useFundingCalcPrompt(
  clientId: string | null,
  fundingSourceId: string | null,
  enabled: boolean,
) {
  return useQuery({
    queryKey: fundingCalcPromptKeys.detail(
      `${clientId ?? ''}::${fundingSourceId ?? ''}`,
    ),
    queryFn: () =>
      fundingCalcPromptApi.getByClientId(clientId!, fundingSourceId ?? undefined),
    enabled: enabled && !!clientId,
    staleTime: 0,
    gcTime: 0,
    retry: false,
  });
}

export function useWizardFundingSources(clientId: string | null) {
  return useQuery({
    queryKey: fundingSourcesKeys.detail(clientId ?? ''),
    queryFn: () => fundingCalcPromptApi.listFundingSources(clientId!),
    enabled: !!clientId,
    staleTime: 0,
    gcTime: 0,
    retry: false,
  });
}
